module.exports = __webpack_public_path__ + "img/NW07.74887f09.gif";